import { useForm } from "react-hook-form";
import { CustomInputOtp } from "../../shared/components/allInput";
import { useNavigate } from "react-router-dom";
import CustomButton from "shared/components/inputButton";
import Layout from "../../layout/common/authLayout";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { RegisterAction, requestOtpAction, verifyOtpAction } from "store/actions/AuthActions";

const OtpVerification = ({ data, type, setStep }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [isOtpSending, setIsOtpSending] = useState(false)
    const [timer, setTimer] = useState(60);
    if (!data?.email) navigate("/"); //redirect to the base url if email is empty
    const [formData, setFormData] = useState({
        email: data?.email,
        otp: "",
        otpType: type
    })

    useEffect(() => {
        const timeInterval = setInterval(() => {
            if (timer > 0) {
                let newTime = timer - 1;
                setTimer(newTime);
            }
        }, 1000);

        return () => {
            clearInterval(timeInterval);
        };
    }, [timer]);

    const handleChange = ({ name, value }) => {
        setFormData((prev) => ({ ...prev, [name]: value }))
    }

    const onSubmit = async () => {
        dispatch(verifyOtpAction(formData, setLoading, dispatch, (res) => {
            if (type == 1) {
                dispatch(RegisterAction(data, setLoading, dispatch, navigate))
            } else {
                setStep && setStep(2)
            }
        }))
    };

    const resendOtp = () => {
        dispatch(requestOtpAction({ email: data?.email, otpType: type }, setIsOtpSending, dispatch, (res) => {
            setTimer(60);
            setFormData((prev) => ({ ...prev, otp: "" }))
        }))
    }

    return (
        <>
            <h2 className={`text-2xl md:text-4xl text-left py-1 mb-2 `}>
                OTP Verification
            </h2>
            {/* <Layout title="OTP Verification"> */}
            <form className="mt-5 pt-2">
                <div className="flex justify-content-center">
                    <CustomInputOtp
                        name={"otp"}
                        data={formData}
                        onChange={handleChange}
                    />
                </div>
                <div className="mt-2 text-center">
                    Did Not Receive a Verification Code?
                    <span className="pl-2">
                        {(!isOtpSending) && !timer ? (
                            <b className="cursor-pointer disabled" onClick={resendOtp}>
                                Resend
                            </b>
                        ) : (!isOtpSending) && <b className="cursor-pointer disabled">
                            {timer} s
                        </b>}
                    </span>
                </div>
                <CustomButton
                    type="button"
                    label="Continue"
                    extraClassName="mb-5 mt-5 w-full"
                    disabled={formData?.otp?.length !== 6}
                    loading={loading}
                    onClick={onSubmit}
                />
            </form>
            {/* </Layout > */}
        </>
    );
};

export default OtpVerification;
